var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"tile notification",class:_vm.color},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.msg))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }